const baseDomain = process.env.VUE_APP_API_DOMAIN;

export default {
  environment: process.env.NODE_ENV,

  baseApiDomain: baseDomain,

  baseApiUrl: `${baseDomain}/api/v1`,

  avatarUrl: 'https://hq.orangetalent.net/storage/avatars/',

  apiRoutes: {
    sanctumCsrf: '/sanctum/csrf-cookie',
    user: '/support/user',
    login: '/support/login',
    loginCheck: '/support/login/check',
    register: '/support/register',
    passwordReset: '/support/password/reset',
    tickets: '/support/ticket',
    ticketCreate: '/support/ticket',
    ticket: '/support/ticket/{id}',
    ticketState: '/support/ticket-status/{id}',
    ticketReplyCreate: '/support/ticket-reply/{id}',
    ticketTypes: '/support/ticket-type',
  },

  sentryDsn: process.env.VUE_APP_SENTRY_DSN,
};
